module.exports = __webpack_public_path__ + "static/img/bgt1.c094e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/IntegralProject/images/bgt1.png
// module id = 2HCN
// module chunks = 5